<script lang="ts">
    import type Konva from 'konva';
    import {Image, Layer, Rect, Stage, Transformer, Text} from 'svelte-konva';
    import {Button, Hr, Input} from "flowbite-svelte";
    import {onMount} from "svelte";
    import {deleteContractField, postContractField, updateContractField} from "$lib/calls/document";

    export let image: any = null;
    export let page = 1;

    export let contract: any;
    export let fields: Array<any> = [];

    // let rectangles: Array<any> = [];
    let contractCanvas: any = null;

    let transformer: Konva.Transformer;
    let selectedShapeName = "";
    let localFields: Array<any> = [];

    function handleStageMouseDown(e) {
        const konvaEvent = e.detail;
        // clicked on stage - clear selection
        if (konvaEvent.target === konvaEvent.target.getStage()) {
            selectedShapeName = "";
            updateTransformer();
            return;
        }

        // clicked on transformer - do nothing
        const clickedOnTransformer =
            konvaEvent.target.getParent().className === "Transformer";
        if (clickedOnTransformer) {
            return;
        }

        // find clicked rect by its name
        const name = konvaEvent.target.name();
        const rect = localFields.find((r) => r.name === name);
        if (rect) {
            selectedShapeName = name;
        } else {
            selectedShapeName = "";
        }

        updateTransformer();
    }

    function handleTransformEnd(ev: CustomEvent|null = null) {
        // find element in our state
        const rect = localFields.find((r) => r.name === selectedShapeName);

        if(ev && ev.detail.target.attrs?.scaleX) {
            rect.scaleX = ev.detail.target.attrs.scaleX || 1;
            rect.scaleY = ev.detail.target.attrs.scaleY || 1;
        }

        // localFields = [...localFields.filter(x => x.name !== selectedShapeName), rect];

        storeField(rect)

    }

    function updateTransformer() {
        if (!transformer) return;

        // here we need to manually attach or detach Transformer node
        const stage = transformer.getStage();

        const selectedNode = stage.findOne("." + selectedShapeName);

        // do nothing if selected node is already attached
        if (selectedNode === transformer.node()) {
            return;
        }

        if (selectedNode) {
            // attach to another node
            transformer.nodes([selectedNode]);
        } else {
            // remove transformer
            transformer.nodes([]);
        }
    }

    function signatureEmployee() {
        createNewField("rgba(37,37,217,0.2)", "Signature: employee")
    }
    function signatureCompany() {
        createNewField("rgba(255,85,0,0.21)", "Signature: company")
    }

    function textEmployee() {
        createNewField("rgba(48,200,60,0.2)", "Text: employee")
    }
    function textCompany() {
        createNewField("rgba(59,104,38,0.21)", "Text: company")
    }

    function dateEmployee() {
        createNewField("rgba(193,23,221,0.21)", "Date: employee")
    }
    function dateCompany() {
        createNewField("rgba(137,14,137,0.21)", "Date: company")
    }

    function createNewField(color:string, type:string, label:string = "") {
        localFields = [...localFields, {
            name: "rect-" + localFields.length,
            x: 30,
            y: 50,
            width: 100,
            height: 40,
            fill: color,
            type: type,
            shadowBlur: 10,
            label: label,
            templateDocumentId: contract.id,
            page: page,
            draggable: true}
        ];
    }

    function deleteRectangle(rect:any) {
        if(rect.id){
            rect.id = parseInt(rect.id.replace('id-', ''))
            deleteContractField(rect)
        }

        localFields = localFields.filter((r) => r.name !== rect.name);
    }

    async function storeField(field:any) {
        field = {...field}
        field.x = field.x / image.width * 100
        field.y = field.y / image.height * 100
        field.width = field.width * field.scaleX / image.width * 100
        field.height = field.height * field.scaleY / image.height * 100
        if(field.id){
            // field.id = parseInt(field.id.replace('id-', ''))
            field = await updateContractField({...field, id: parseInt(field.id.replace('id-', ''))})
        } else {
            field = await postContractField(field);
        }
        localFields = [...localFields.filter(x => x.id !== 'id-' + field.id), fieldToLocalField(field)];

    }
    function fieldToLocalField(field: any) {
        const type = field.type.charAt(0).toUpperCase() + field.type.slice(1) + ": " + field.target
        return {
            id: 'id-' + field.id,
            name: "rect-" + localFields.length,
            x: image.width * field.x / 100,
            y: image.height * field.y / 100,
            scaleX: field.scaleX || 1,
            scaleY: field.scaleY || 1,
            width: image.width * field.width / 100,
            height: image.height * field.height / 100,
            fill: type === "Signature: company" ? "rgba(255,85,0,0.21)" : "rgba(37,37,217,0.2)",
            type: type,
            label: field.label,
            templateDocumentId: field.templateDocumentId,
            page: field.page,
            draggable: true
        }
    }

    onMount(() => {

        const stop = setInterval(() => {
            if(contractCanvas){
                image.height =  contractCanvas.offsetWidth / image.width * image.height
                image.width = contractCanvas.offsetWidth
                fields.forEach(field => {
                    if(field.page !== page) return
                    localFields = [...localFields, fieldToLocalField(field)]
                })
                clearInterval(stop);
            }
        }, 200)


    })

</script>
<div class="flex gap-2 mt-7">
    <Button on:click={signatureEmployee} class="block mb-1 whitespace-nowrap">Signature: employee</Button>
    <Button on:click={signatureCompany}  class="block mb-1">Signature: company</Button>
    <Button on:click={textCompany} color="alternative" class="block mb-1">Text: company</Button>
    <Button on:click={textEmployee} color="alternative" class="block mb-1">Text: employee</Button>
    <Button on:click={dateCompany} outline class="block mb-1">Date: company</Button>
    <Button on:click={dateEmployee} outline class="block mb-1">Date: employee</Button>
</div>
<div class="flex gap-3 w-full">
    <div class="flex-1" bind:this={contractCanvas}>
        <Stage
                on:mousedown={handleStageMouseDown}
                config={{width: contractCanvas?.offsetWidth, height: image?.height  }}>
            <Layer>
                <Image config={{ image }}/>
                {#each localFields as rectangle}
                    <Rect config={rectangle} on:transformend={handleTransformEnd} on:dragend={handleTransformEnd}/>
                {/each}

                <Transformer bind:handle={transformer}/>
            </Layer>
        </Stage>
    </div>
    <div class="w-64">
        <p>{selectedShapeName}</p>
        {#each localFields as rectangle}
            <div class="flex gap-5 items-center">
                <div class="w-5 h-5" style="background: {rectangle.fill}"></div>
                <div>{rectangle.type}</div>
                <div>
                    <Button size="xs" color="red" on:click={() => deleteRectangle(rectangle)}>x</Button>
                </div>
            </div>
            <div class="grid grid-cols-2 mb-5">
                <div>x: {rectangle.x.toFixed(1)}</div>
                <div>y: {rectangle.y.toFixed(1)}</div>
                <div>width: {(rectangle.width * (rectangle.scaleX ?? 1)).toFixed(1)}</div>
                <div>height: {(rectangle.height * (rectangle.scaleY ?? 1)).toFixed(1)}</div>
                <div class="col-span-2">
                    <Input on:change={(e) => storeField(rectangle)} placeholder="Label" bind:value={rectangle.label}/>
                </div>
            </div>

        {/each}
    </div>
</div>
